import { createApp } from "vue";
import App from "./App.vue";

// Plugins
import globalVariables from "./plugins/globalVariables";
import router from "./utilities/router";

import stores from "./utilities/stores";
import i18n from "./utilities/language";

import { VueSvgIconPlugin } from "@yzfe/vue3-svgicon";
import "@yzfe/svgicon/lib/svgicon.css";

import VueSocialSharing from "vue-social-sharing";

const app = createApp(App);

app.use(VueSvgIconPlugin, { tagName: "icon" });
app.use(globalVariables);
app.use(router);
app.use(i18n);
app.use(stores);
app.use(VueSocialSharing);

// Add mount in DOMContentLoaded listener to be sure JS is executed first before prerendering
document.addEventListener("DOMContentLoaded", function () {
  app.mount("#app");
});
